<template lang="pug">
  .SlotsTimePicker
    .d-flex(v-for="slot, i in timeSlots" :key="i")
      .d-flex-grow-1
        v-dialog(
          v-model="dialogsFrom[i]"
          width="290px"
          :return-value.sync="timeSlots[i].from"
          :ref="`dialogFrom${i}`"
        )
          template(v-slot:activator="{ on }")
            v-text-field(
              v-model="timeSlots[i].from"
              label="Dalle"
              prepend-icon="mdi-clock"
              readonly
              v-on="on"
              clearable
            )
          v-time-picker(
            v-if="dialogsFrom[i]"
            v-model="timeSlots[i].from"
            full-width
            format="24hr"
            @click:minute="$refs[`dialogFrom${i}`][0].save(timeSlots[i].from)"
          )
      .d-flex-grow-1.pl-3
        v-dialog(
          v-model="dialogsTo[i]"
          width="290px"
          :return-value.sync="timeSlots[i].to"
          :ref="`dialogTo${i}`"
        )
          template(v-slot:activator="{ on }")
            v-text-field(
              v-model="timeSlots[i].to"
              label="Alle"
              readonly
              v-on="on"
              clearable
            )
          v-time-picker(
            v-if="dialogsTo[i]"
            v-model="timeSlots[i].to"
            full-width
            format="24hr"
            @click:minute="$refs[`dialogTo${i}`][0].save(timeSlots[i].to)"
          )
</template>

<script>
export default {
  name: "SlotsTimePicker",
  watch: {
    timeSlots: {
      immediate: true,
      handler() {
        while (this.dialogsFrom.length < this.timeSlots.length) {
          this.dialogsFrom.push(false);
          this.dialogsTo.push(false);
        }
      }
    }
  },
  props: {
    timeSlots: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      dialogsFrom: [],
      dialogsTo: []
    };
  },
  created() {
    while (this.dialogsFrom.length < this.timeSlots.length) {
      this.dialogsFrom.push(false);
      this.dialogsTo.push(false);
    }
  },
  methods: {
    closeDialogFrom(i) {
      this.$set(this.dialogsFrom, i, false);
    },

    closeDialogTo(i) {
      this.dialogsTo[i] = false;
    }
  }
};
</script>
